import { registerVizType } from '../../../model/viz/visualizationTypes';
import { DistributionChartViz } from "./distributionChartViz";
import { ResolvedParams } from "../../../model/params/resolve/ResolvedParams";
import { services } from "../../../../application/service/services";
import { getTitle } from "../common";
import {AbstractTableVizComponent, TableData} from "../table/AbstractTableViz";

registerVizType({
  name: 'DISTRIBUTION_CHART',
  component: DistributionChartViz,
  title: getTitle,
  noDataPolicy: {
    hasData: vizInstance => {
      return vizInstance.data.totalCount > 0;
    }
  },
  editable: true,
  specResolver: (vizDefinitionSpec, resolvedParams: ResolvedParams) => {
    const params = vizDefinitionSpec.params;

    if (params.inclusions) {
      params.inclusions.forEach(inclusion => {
        const field = services.getFieldsService().getField(inclusion.field);
        /*check all  inclusions and exclusions values to replace first_level value with all corresponding values*/
        params.inclusions = services.getDashboardService().resolveFirstLevelValues(field, inclusion.values);
      });
    }

    if (params.exclusions) {
      params.exclusions.forEach(exclusion => {
        const field = services.getFieldsService().getField(exclusion.field);
        /*check all  inclusions and exclusions values to replace first_level value with all corresponding values*/
        params.exclusions = services.getDashboardService().resolveFirstLevelValues(field, params.exclusions);

      });
    }
    return vizDefinitionSpec;
  },
  prepareViz: (vizDefinitionSpec, data: TableData) => {
    /*for each item in date, we register the value in color service to assign it a color*/
    AbstractTableVizComponent.declareColor(data);
  },
  prepareData: (data) => {
    return {
      items: AbstractTableVizComponent.enrichItems(data.items, null),
      totalCount: data.totalCount,
      childrenCount: data.childrenCount
    };
  }
});